import { usePageContext } from "vike-react/usePageContext"

// The help center home as the server rendered it (aldoo-ra/HelpCenter/ssr.js,
// `helpCenterSSR.home`): its sections start from it on the server and on the
// first client render while the page and language are still the same ones.
export const useHelpCenterHomeSeed = (language) => {
  let pageContext = null
  try {
    pageContext = usePageContext()
  } catch {
    return null
  }
  const ssr = pageContext?.helpCenterSSR
  if (!ssr?.home) return null
  if (typeof window === "undefined") return ssr.home
  const samePage = window.location.pathname === ssr.pathname && (ssr.language || "en") === language
  return samePage ? ssr.home : null
}

export default useHelpCenterHomeSeed
